import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class Setting extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/setting/get")
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {    
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/setting/save", {
            gw1CallbackUrl: this.state.data.record.gw1CallbackUrl,
            gw1Username: this.state.data.record.gw1Username,
            gw1Password: this.state.data.record.gw1Password,
            g1Terminal: this.state.data.record.g1Terminal,
            gw3CallbackUrl: this.state.data.record.gw3CallbackUrl,
            gw3ApiKey: this.state.data.record.gw3ApiKey,
            link1Text: this.state.data.record.link1Text,
            link2Text: this.state.data.record.link2Text,
            link3Text: this.state.data.record.link3Text,
            link1Url: this.state.data.record.link1Url,
            link2Url: this.state.data.record.link2Url,
            link3Url: this.state.data.record.link3Url,
            activeGateWay: this.state.data.record.activeGateWay
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return<div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div className="components-preview wide-md mx-auto">
                                    <div className="nk-block-head nk-block-head-lg wide-sm">
                                        <div className="nk-block-head-content">
                                            <div className="nk-block-head-sub">
                                                <a className="back-to" to="/units/"><em className="icon ni ni-arrow-left"></em><span>تنظیمات</span></a>
                                             </div>
                                        </div>
                                    </div>
									<div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">تنظیمات سیستم</h5>
                                                </div>
                                                <form method="post" onSubmit={e=>this.save(e)} className="row g-4">
                                                    <div className="col-lg-5">
                                                        <div className="form-group">
                                                            <label className="form-label">Api درگاه زیبال</label>
                                                            <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.gw3ApiKey} onChange={e => this.state.data.record.gw3ApiKey = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-5">
                                                        <div className="form-group">
                                                    <label className="form-label">آدرس بازگشت درگاه زیبال</label>
                                                        <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.gw3CallbackUrl} onChange={e => this.state.data.record.gw3CallbackUrl = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                            <div className="col-lg-2">
                                                <div className="form-group">
                                                    <label className="form-label">درگاه فعال</label>
                                                    <div className="form-control-wrap">
                                                        <select className="form-control" defaultValue={this.state.data.record.activeGateWay} onChange={e => this.state.data.record.activeGateWay = parseInt(e.target.value)}>
                                                            <option value="5">زیبال</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">متن لینک اول</label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.link1Text} onChange={e => this.state.data.record.link1Text = e.target.value} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">آدرس لینک اول</label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.link1Url} onChange={e => this.state.data.record.link1Url = e.target.value} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">متن لینک دوم</label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.link2Text} onChange={e => this.state.data.record.link2Text = e.target.value} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">آدرس لینک دوم</label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.link2Url} onChange={e => this.state.data.record.link2Url = e.target.value} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">متن لینک سوم</label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.link3Text} onChange={e => this.state.data.record.link3Text = e.target.value} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">آدرس لینک سوم</label>
                                                    <div className="form-control-wrap">
                                                        <input className="form-control" type="text" defaultValue={this.state.data.record.link3Url} onChange={e => this.state.data.record.link3Url = e.target.value} />
                                                    </div>
                                                </div>
                                            </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}